import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { DialogContentText, TextField, Tooltip } from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import InputAdornment from "@material-ui/core/InputAdornment";
import isEmpty from "lodash/isEmpty";
import emailjs from "emailjs-com";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#bac8f4",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
  },
  formControl: {
    marginTop: theme.spacing(2),
    width: 400,
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
  icon: {
    color: "antiquewhite",
    cursor: "pointer",
    fontSize: 22,
    marginRight: 10,
  },
}));

let initialForm = {
  email: "",
  suggestion: "",
};

export default function Contact() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [form, setForm] = React.useState(initialForm);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleForm = (event) => {
    event.preventDefault();
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSubmit = () => {
    const data = {
      from_name: form.email,
      to_name: "Mohamet",
      message: form.suggestion,
      reply_to: "",
    };
    emailjs
      .send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        data,
        process.env.REACT_APP_USER_ID
      )
      .then((response) => {
        console.log("Thank you 🥳");
      })
      .catch();

    handleClose();
    setForm(initialForm);
  };

  return (
    <React.Fragment>
      <Tooltip title="Suggestions" arrow>
        <MailOutlineIcon onClick={handleClickOpen} className={classes.icon} />
      </Tooltip>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        aria-labelledby="settings"
      >
        <DialogTitle className={classes.root} id="settings">
          Suggestions
        </DialogTitle>
        <DialogContent className={classes.root}>
          <DialogContentText>Do you have any suggestions?</DialogContentText>
          <form className={classes.form}>
            <FormControl className={classes.formControl}>
              <TextField
                className={classes.margin}
                id="input-with-icon-textfield"
                name="email"
                type="email"
                placeholder="address email"
                defaultValue={form.email}
                onChange={handleForm}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            <FormControl className={classes.formControl}>
              <TextField
                id="filled-multiline-static"
                label="Suggestions"
                name="suggestion"
                multiline
                rows={6}
                defaultValue={form.suggestion}
                onChange={handleForm}
                variant="filled"
              />
            </FormControl>
          </form>
        </DialogContent>
        <DialogActions className={classes.root}>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            disabled={isEmpty(form.suggestion) || isEmpty(form.email)}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
